<template>
  <v-container fluid class="mt-5 pt-8 px-1 mx-0">
    <template v-if="dataLoading">
      <v-card elevation="0" color="transparent" height="85vh">
        <v-layout align-center justify-center column fill-height>
          <v-flex row align-center justify-center column fill-height>
            <v-progress-circular
              :size="70"
              color="#87CEFA"
              indeterminate
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
    <template v-if="!dataLoading && games.length == 0">
      <div class="text-center my-10" style="max-width: 100vw">
        <v-icon size="75">mdi-alert-octagram-outline</v-icon>
        <br />
        <span style="color: black"> Ничего не найдено :( </span>
        <discard-button class="d-flex justify-center" @filter_update="getData">
        </discard-button>
      </div>
    </template>
    <template
      class="notranslate"
      v-else-if="dateDifference != '' && games.length != 0 && !dataLoading"
    >
      <v-card class="main_table rounded-xl" elevation="5">
        <v-toolbar dense flat class="title d-flex justify-center pt-2" color=""
          >Статистика MKX
        </v-toolbar>
        <v-row class="pa-2 ma-2">
          <th v-if="isMobile">
            <v-btn small :elevation="2" class="mr-2" @click="scale -= 1">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
          </th>
          <th v-if="isMobile">
            <v-btn small :elevation="2" @click="scale += 1">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </th>
        </v-row>
        <v-row class="pa-2 ma-2">
          <v-spacer></v-spacer>
          <!-- {{ this.expire_date }} -->
          <!-- {{ this.sub_type }} -->
          <update-template-button
            v-if="
              this.getIsTemplateChanged() === true ||
              this.getIsTemplateChanged() === 'true'
            "
          ></update-template-button>
          <discard-changes-button
            v-if="
              this.getIsTemplateChanged() === true ||
              this.getIsTemplateChanged() === 'true'
            "
            @filter_update="getData"
          >
          </discard-changes-button>

          <th>
            <v-tooltip v-if="dateDifference != ''" top>
              <template v-slot:activator="{ on }">
                <v-chip
                  outlined
                  label
                  color="green lighten-2"
                  class="ma-2"
                  height="32px"
                  v-on="on"
                >
                  {{ dateDifference }}
                  <!-- {{ declOfNumDay(dateDifference.days) }}
                  {{ dateDifference.hours }}
                  {{ declOfNumHour(dateDifference.hours) }}
                  {{ dateDifference.minutes }}
                  {{ declOfNumMin(dateDifference.minutes) }} -->
                </v-chip>
              </template>
              <span>Оставшееся время подписки</span>
            </v-tooltip>
          </th>
          <th>
            <v-tooltip v-if="templateName" top>
              <template v-slot:activator="{ on }">
                <v-chip
                  outlined
                  label
                  color="blue"
                  class="ma-2"
                  height="32px"
                  v-on="on"
                >
                  {{ templateName }}
                </v-chip>
              </template>
              <span>Имя выбранного шаблона</span>
            </v-tooltip>
          </th>
        </v-row>
        <v-row class="pa-2 ma-2" align="start">
          <page-size
            @page_size_change="dataLoading = true && getData()"
          ></page-size>
          <new-template></new-template>
          <col-settings></col-settings>
          <color-settings></color-settings>
          <!-- <save-template-button
            @clear_selection="clearSelection"
          ></save-template-button> -->
          <!-- <palette-dialog></palette-dialog> -->
          <template-dialog
            @selection_update="updateSelection"
            @filter_update="getData"
          >
          </template-dialog>
        </v-row>
        <v-simple-table
          v-if="!dataLoading && games"
          class="text-center main_table"
          :items="games"
          :headers="filterCols(headers)"
          item-key="id"
          :server-items-length="totalGames"
        >
          <thead class="caption">
            <tr>
              <!-- :NEW -->
              <!-- <th></th> -->
              <th v-if="inCols('id')"></th>
              <th v-if="inCols('Дата')"></th>
              <th v-if="inCols('Время суток')"></th>
              <th colspan="2">
                <highlight-fighters></highlight-fighters>
              </th>
              <th></th>
              <th v-if="inCols('Раунды')" colspan="9">
                <finish-selection></finish-selection>
              </th>
              <th v-if="inCols('П1 | П2')" class="text-center" colspan="2">
                <winner-match-coef-highlight></winner-match-coef-highlight>
              </th>
              <th v-if="inCols('П1Р | П2Р')" colspan="2">
                <winner-coef-highlight></winner-coef-highlight>
              </th>
              <th v-if="inCols('F | B | R')" colspan="3">
                <finish-coef-highlight></finish-coef-highlight>
              </th>
              <!-- <th v-if="inCols('П1Р | П2Р')" class="text-center">п1р</th>
            <th v-if="inCols('П1Р | П2Р')" class="text-center">п2р</th>
            <th v-if="inCols('F | B | R')" class="text-center">F</th>
            <th v-if="inCols('F | B | R')" class="text-center">B</th>
            <th v-if="inCols('F | B | R')" class="text-center">R</th> -->
              <th v-if="inCols('Чистая победа')" class="text-center">ЧП</th>
              <th v-if="inCols('5.5Б')" class="text-center">5.5Б</th>
              <th v-if="inCols('5.5М')" class="text-center">5.5М</th>
              <th v-if="inCols('6.5Б')" class="text-center">6.5Б</th>
              <th v-if="inCols('6.5М')" class="text-center">6.5М</th>
              <th v-if="inCols('7.5Б')" class="text-center">7.5Б</th>
              <th v-if="inCols('7.5М')" class="text-center">7.5М</th>
              <th v-if="inCols('8.5Б')" class="text-center">8.5Б</th>
              <th v-if="inCols('8.5М')" class="text-center">8.5М</th>
              <th v-if="inCols('Разница времени')" class="text-center"></th>
              <th v-if="inCols('Время')" class="text-center" colspan="9">
                <time-highlight></time-highlight>
              </th>
            </tr>

            <tr>
              <th
                v-for="header in filterCols(headers)"
                :key="header.id"
                class="text-center"
              >
                {{ header.text }}
              </th>
            </tr>
            <tr class="filter_row">
              <!-- :NEW -->
              <!-- <th></th> -->
              <id-filter
                ref="id"
                v-if="inCols('id')"
                @filter_update="getData"
              ></id-filter>
              <date-picker
                ref="date"
                v-if="inCols('Дата')"
                v-on:filter_update="getData"
              ></date-picker>
              <time-picker
                ref="daytime"
                v-if="inCols('Время суток')"
                v-on:filter_update="getData"
              ></time-picker>

              <value-dialog
                v-on:filter_update="getData"
                ref="left_fighter"
                entity="fighters__"
                name="left_fighter"
                id="fighter_left_f"
              ></value-dialog>
              <value-dialog
                v-on:filter_update="getData"
                entity="fighters__"
                ref="right_fighter"
                name="right_fighter"
                id="fighter_right_f"
              ></value-dialog>
              <score-filter
                entity="score__"
                @filter_update="getData"
              ></score-filter>
              <template v-if="inCols('Раунды')">
                <round-filter
                  ref="rounds_view__one_view"
                  @filter_update="getData"
                  num="one"
                ></round-filter>
                <round-filter
                  ref="rounds_view__two_view"
                  @filter_update="getData"
                  num="two"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__three_view"
                  num="three"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__four_view"
                  num="four"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__five_view"
                  num="five"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__six_view"
                  num="six"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__seven_view"
                  num="seven"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__eight_view"
                  num="eight"
                ></round-filter>
                <round-filter
                  @filter_update="getData"
                  ref="rounds_view__nine_view"
                  num="nine"
                ></round-filter>
              </template>
              <coef-dialog
                v-if="inCols('П1 | П2')"
                entity="coefs__"
                cf_type="wl"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('П1 | П2')"
                entity="coefs__"
                cf_type="wr"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('П1Р | П2Р')"
                entity="coefs__"
                cf_type="wlr"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('П1Р | П2Р')"
                entity="coefs__"
                cf_type="wrr"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('F | B | R')"
                entity="coefs__"
                cf_type="f"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('F | B | R')"
                entity="coefs__"
                cf_type="b"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('F | B | R')"
                entity="coefs__"
                cf_type="r"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('Чистая победа')"
                entity="coefs__"
                cf_type="flaw"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('5.5Б')"
                entity="totals__"
                cf_type="five_total_more"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('5.5М')"
                entity="totals__"
                cf_type="five_total_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('6.5Б')"
                entity="totals__"
                cf_type="six_total_more"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('6.5М')"
                entity="totals__"
                cf_type="six_total_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('7.5Б')"
                entity="totals__"
                cf_type="seven_total_more"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('7.5М')"
                entity="totals__"
                cf_type="seven_total_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('8.5Б')"
                entity="totals__"
                cf_type="eight_total_more"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('8.5М')"
                entity="totals__"
                cf_type="eight_total_less"
                @filter_update="getData"
              ></coef-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="first_t"
                id="first_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="second_t"
                id="second_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="third_t"
                id="third_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="fourth_t"
                id="fourth_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="fifth_t"
                id="fifth_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="sixth_t"
                id="sixth_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="seventh_t"
                id="seventh_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="eighth_t"
                id="eighth_t"
              ></time-dialog>
              <time-dialog
                v-if="inCols('Время')"
                v-on:filter_update="getData"
                entity="rounds_time__"
                name="ninth_t"
                id="ninth_t"
              ></time-dialog>
              <!-- <th v-if="inCols('Разница времени')"></th> -->
              <time-diff-dialog
                v-if="inCols('Разница времени')"
                @filter_update="getData"
              ></time-diff-dialog>
              <time-dialog
                v-if="inCols('Меньшее')"
                v-on:filter_update="getData"
                entity="round_time__"
                name="min_time"
                id="min_time"
              ></time-dialog>
              <coef-dialog
                v-if="inCols('Меньшее')"
                entity="time_coef__"
                cf_type="min_coef_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('Меньшее')"
                entity="time_coef__"
                cf_type="min_coef_more"
                @filter_update="getData"
              ></coef-dialog>
              <time-dialog
                v-if="inCols('Среднее')"
                v-on:filter_update="getData"
                entity="round_time__"
                name="mean_time"
                id="mean_time"
              ></time-dialog>
              <coef-dialog
                v-if="inCols('Среднее')"
                entity="time_coef__"
                cf_type="mean_coef_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('Среднее')"
                entity="time_coef__"
                cf_type="mean_coef_more"
                @filter_update="getData"
              ></coef-dialog>
              <time-dialog
                v-if="inCols('Большее')"
                v-on:filter_update="getData"
                entity="round_time__"
                name="max_time"
                id="max_time"
              ></time-dialog>
              <coef-dialog
                v-if="inCols('Большее')"
                entity="time_coef__"
                cf_type="max_coef_less"
                @filter_update="getData"
              ></coef-dialog>
              <coef-dialog
                v-if="inCols('Большее')"
                entity="time_coef__"
                cf_type="max_coef_more"
                @filter_update="getData"
              ></coef-dialog>
            </tr>
          </thead>

          <tbody v-if="totalGames == 0">
            <td :colspan="filterCols(headers).length" style="border: 0px">
              <div class="text-center my-10" style="max-width: 100vw">
                <v-icon size="75">mdi-alert-octagram-outline</v-icon>
                <br />
                <span style="color: grey"> Ничего не найдено :( </span>
              </div>
            </td>
          </tbody>
          <tbody v-else-if="totalGames != 0" class="">
            <tr
              v-for="game in games"
              v-bind:key="first_score(game) + second_score(game) + game.id"
            >
              <template>
                <!-- :NEW -->
                <!-- <td>
                  <v-btn
                    x-small
                    plain
                    class="align-self-start subtitle-1 text-none"
                    color="black"
                    target="_blank"
                    text
                    to="pair_stats"
                  >
                    <v-icon x-small>mdi-check</v-icon>
                  </v-btn>
                </td> -->
                <td v-if="inCols('id')" style="">
                  {{ game.id }}
                </td>
                <td v-if="inCols('Дата')" style="white-space: nowrap">
                  {{ game.timestamp[0].ts.split("T")[0] }}
                </td>
                <td
                  v-if="inCols('Время суток')"
                  @click="setDayTime(prepareTime(game))"
                  v-bind:style="{ cursor: 'pointer' }"
                >
                  {{ prepareTime(game) }}
                </td>
                <td
                  id="left_fighter"
                  v-bind:style="{
                    cursor: 'pointer',
                    backgroundColor: isHighlight(game, 'left'),
                  }"
                  @click="setFighters(game.fighters[0])"
                >
                  {{ game.fighters[0].left_fighter }}
                </td>
                <td
                  id="right_fighter"
                  v-bind:style="{
                    cursor: 'pointer',
                    backgroundColor: isHighlight(game, 'right'),
                  }"
                  @click="setFighters(game.fighters[0])"
                >
                  {{ game.fighters[0].right_fighter }}
                </td>
                <!-- <td v-bind:class="{ rusk: game.score[0].is_rusk }"> -->
                <td
                  v-bind:class="{ rusk: game.score[0].is_rusk }"
                  v-if="game.score[0]"
                >
                  {{ game.score[0].first_score }}:{{
                    game.score[0].second_score
                  }}
                </td>

                <!-- style="
                      min-width: 10px;
                      max-width: 100px;
                      white-space: nowrap;
                    " -->

                <!-- fat: isFinish(round, 'F'),
                      hand: isFinish(round, 'R'),
                      out_win: isFinish(round, 'out', game.coefs[0]),
                      fav_win: isFinish(round, 'fav', game.coefs[0]),
                      w1: isFinish(round, '1:0'),
                      w2: isFinish(round, '0:1'), -->
                <template v-if="inCols('Раунды')">
                  <td
                    style="width: 50px"
                    v-bind:style="{
                      backgroundColor: isFinish(round, game.coefs[0]),
                    }"
                    v-for="(round, index) in rounds(game)"
                    :key="index"
                  >
                    {{ round }}
                  </td>
                </template>

                <td
                  v-if="inCols('П1 | П2')"
                  v-bind:style="{
                    backgroundColor: getWinnerMatchCoefClass('left', game),
                  }"
                >
                  {{ game.coefs[0].wl }}
                </td>
                <td
                  v-if="inCols('П1 | П2')"
                  v-bind:style="{
                    backgroundColor: getWinnerMatchCoefClass('right', game),
                  }"
                >
                  {{ game.coefs[0].wr }}
                </td>
                <td
                  v-if="inCols('П1Р | П2Р')"
                  v-bind:style="{
                    backgroundColor: getWinnerCoefClass(
                      '1:0',
                      raw_rounds(game)
                    ),
                  }"
                >
                  {{ game.coefs[0].wlr }}
                </td>
                <td
                  v-if="inCols('П1Р | П2Р')"
                  v-bind:style="{
                    backgroundColor: getWinnerCoefClass(
                      '0:1',
                      raw_rounds(game)
                    ),
                  }"
                >
                  {{ game.coefs[0].wrr }}
                </td>
                <td
                  v-if="inCols('F | B | R')"
                  v-bind:style="{
                    backgroundColor: getFinishCoefClass('F', rounds(game)),
                  }"
                >
                  {{ game.coefs[0].f }}
                </td>
                <td
                  v-if="inCols('F | B | R')"
                  v-bind:style="{
                    backgroundColor: getFinishCoefClass('B', rounds(game)),
                  }"
                >
                  {{ game.coefs[0].b }}
                </td>
                <td
                  v-if="inCols('F | B | R')"
                  v-bind:style="{
                    backgroundColor: getFinishCoefClass('R', rounds(game)),
                  }"
                >
                  {{ game.coefs[0].r }}
                </td>
                <td v-if="inCols('Чистая победа')">
                  {{ game.coefs[0].flaw }}
                </td>
                <!-- <td v-for="coef in game.coefs[0]" :key="coef.id">
                      {{ coef }}
                    </td> -->

                <td v-if="inCols('5.5Б')">
                  {{ game.totals[0].five_total_more }}
                </td>
                <td v-if="inCols('5.5М')">
                  {{ game.totals[0].five_total_less }}
                </td>
                <td v-if="inCols('6.5Б')">
                  {{ game.totals[0].six_total_more }}
                </td>
                <td v-if="inCols('6.5М')">
                  {{ game.totals[0].six_total_less }}
                </td>
                <td v-if="inCols('7.5Б')">
                  {{ game.totals[0].seven_total_more }}
                </td>
                <td v-if="inCols('7.5М')">
                  {{ game.totals[0].seven_total_less }}
                </td>
                <td v-if="inCols('8.5Б')">
                  {{ game.totals[0].eight_total_more }}
                </td>
                <td v-if="inCols('8.5М')">
                  {{ game.totals[0].eight_total_less }}
                </td>
                <!-- <td v-for="total in game.totals[0]" :key="total.id">
                      {{ total }}
                    </td> -->

                <template v-if="inCols('Время')">
                  <td
                    v-for="round_time in game.rounds_time[0]"
                    :key="round_time.id"
                    :style="{ backgroundColor: timeClass(game, round_time) }"
                  >
                    {{ round_time }}
                  </td>
                </template>

                <template v-if="inCols('Разница времени')">
                  <td>
                    {{
                      game.round_time[0].mean_time - game.round_time[0].min_time
                    }}
                    /
                    {{
                      game.round_time[0].max_time - game.round_time[0].mean_time
                    }}
                  </td>
                </template>
                <template v-if="inCols('Меньшее')">
                  <td>
                    {{ game.round_time[0].min_time }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].min_coef_less }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].min_coef_more }}
                  </td>
                </template>

                <template v-if="inCols('Среднее')">
                  <td>
                    {{ game.round_time[0].mean_time }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].mean_coef_less }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].mean_coef_more }}
                  </td>
                </template>

                <template v-if="inCols('Большее')">
                  <td>
                    {{ game.round_time[0].max_time }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].max_coef_less }}
                  </td>
                  <td class="mygrey">
                    {{ game.time_coef[0].max_coef_more }}
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </v-simple-table>
        <pagination @changed="dataLoading = true && getData()"></pagination>
      </v-card>
    </template>
    <template
      v-else-if="
        dateDifference == '' &&
        dateDifference != -1 &&
        games.length > 0 &&
        !dataLoading
      "
    >
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-card class="rounded-xl">
            <v-card-title class="ma-5">
              Для просмотра этого раздела необходимо иметь подписку. <br />
              Оформить её можно на главной странице сайта :)
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                to="/"
                class="text-none headline mb-5"
                color="green lighten-2"
                large
                >На главную</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </template>
  </v-container>
</template>

<script>
// import FighterFilter from "./FighterFilter.vue";
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import IdFilter from "./IdFilter.vue";
import FinishSelection from "./FinishSelection.vue";
import HighlightFighters from "./HighlightFighters.vue";
import TimeHighlight from "./TimeHighlight.vue";
import RoundFilter from "./RoundFilter.vue";
import ScoreFilter from "./ScoreFilter.vue";
import Pagination from "./Pagination.vue";
import CoefDialog from "./CoefDialog.vue";
import TimeDialog from "./TimeDialog.vue";
import TimeDiffDialog from "./TimeDiffDialog.vue";
import ColSettings from "./ColSettings.vue";
import ValueDialog from "./ValueDialog.vue";
import TemplateDialog from "./TemplateDialog.vue";
import NewTemplate from "./NewTemplate.vue";
import PageSize from "./PageSize.vue";
import UpdateTemplateButton from "./UpdateTemplateButton.vue";
import DiscardChangesButton from "./DiscardChangesButton.vue";
import DiscardButton from "./DiscardButton.vue";
import ColorSettings from "./ColorSettings.vue";
// import SaveTemplateButton from "./SaveTemplateButton.vue";
import FinishCoefHighlight from "./FinishCoefHighlight.vue";
// import PaletteDialog from "./PaletteDialog.vue";
import WinnerCoefHighlight from "./colored/WinnerCoefHighlight.vue";
import WinnerMatchCoefHighlight from "./colored/WinnerMatchCoefHighlight.vue";
import api from "../config/api.js";
import { mapGetters, mapMutations, mapActions } from "vuex";

// import axios from "axios";
export default {
  name: "MkTable",
  components: {
    // FighterFilter,
    ColorSettings,
    DatePicker,
    TimePicker,
    PageSize,
    IdFilter,
    FinishSelection,
    HighlightFighters,
    TimeHighlight,
    CoefDialog,
    TimeDialog,
    TimeDiffDialog,
    ColSettings,
    ScoreFilter,
    RoundFilter,
    ValueDialog,
    Pagination,
    NewTemplate,
    TemplateDialog,
    // PaletteDialog,
    // SaveTemplateButton,
    UpdateTemplateButton,
    FinishCoefHighlight,
    WinnerCoefHighlight,
    WinnerMatchCoefHighlight,
    DiscardChangesButton,
    DiscardButton,
  },
  computed: {
    colors: {
      get() {
        return this.getSettings().colors;
      },
    },
    //     set(value) {
    //       this.setColors({ value: value });
    //     },
    //   },

    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // console.log("Is mobile");
        return true;
      } else {
        // console.log("Is not a mobile");
        return false;
      }
    },
    totalGames: function () {
      return this.$store.getters.getTotalGames;
    },
    templateName: function () {
      return this.getCurrentTemplate();
    },
    dateDifference: function () {
      var date_future = new Date(this.getExpireDate());
      var date_now = new Date();
      // console.log("FUTURE:" + date_future);
      // console.log("NOW:" + date_now);
      if (!date_future) {
        return -1;
      }
      var diff = (date_future - date_now) / 1000;
      // console.log("DIFFFF: " + diff);
      if (diff < 0) {
        return "";
      }
      var delta = Math.abs(date_future - date_now) / 1000;

      // calculate (and subtract) whole days
      var days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;
      // console.log("DAYS< :" + days, hours, minutes);

      var result = "";
      if (days > 0) {
        result += days + " " + this.declOfNumDay(days) + " ";
      }
      if (hours > 0) {
        result += hours + " " + this.declOfNumHour(hours) + " ";
      }
      if (minutes > 0) {
        result += minutes + " " + this.declOfNumMin(minutes) + " ";
      }
      return result;
    },
  },
  data() {
    return {
      headers: [
        // :NEW
        // { text: "", value: "pair_stats", name: "pair_stats" },
        { text: "ID", value: "game_id", name: "id" },
        { text: "Дата", value: "date", name: "Дата" },
        { text: "Время", value: "time", name: "Время суток" },
        { text: "Левый", value: "left_fighter", name: "default" },
        { text: "Правый", value: "right_fighter", name: "default" },
        { text: "Счёт", value: "verbose_score", name: "default" },
        { text: "1", value: "first_round", name: "Раунды" },
        { text: "2", value: "2", name: "Раунды" },
        { text: "3", value: "3", name: "Раунды" },
        { text: "4", value: "4", name: "Раунды" },
        { text: "5", value: "5", name: "Раунды" },
        { text: "6", value: "6", name: "Раунды" },
        { text: "7", value: "7", name: "Раунды" },
        { text: "8", value: "8", name: "Раунды" },
        { text: "9", value: "9", name: "Раунды" },
        { text: "П1", value: "w1", name: "П1 | П2" },
        { text: "П2", value: "w2", name: "П1 | П2" },
        { text: "П1Р", value: "w1-round", name: "П1Р | П2Р" },
        { text: "П2Р", value: "w2-round", name: "П1Р | П2Р" },
        { text: "F", value: "F", name: "F | B | R" },
        { text: "B", value: "B", name: "F | B | R" },
        { text: "R", value: "R", name: "F | B | R" },
        { text: "ЧП", value: "FW", name: "Чистая победа" },
        { text: "5.5Б", value: "5.5Б", name: "5.5Б" },
        { text: "5.5М", value: "5.5М", name: "5.5М" },
        { text: "6.5Б", value: "6.5Б", name: "6.5Б" },
        { text: "6.5М", value: "6.5М", name: "6.5М" },
        { text: "7.5Б", value: "7.5Б", name: "7.5Б" },
        { text: "7.5М", value: "7.5М", name: "7.5М" },
        { text: "8.5Б", value: "8.5Б", name: "8.5Б" },
        { text: "8.5М", value: "8.5М", name: "8.5М" },
        { text: "1-Р", value: "rounds_time__first", name: "Время" },
        { text: "2-Р", value: "rounds_time__second", name: "Время" },
        { text: "3-Р", value: "rounds_time__third", name: "Время" },
        { text: "4-Р", value: "rounds_time__fourth", name: "Время" },
        { text: "5-Р", value: "rounds_time__fifth", name: "Время" },
        { text: "6-Р", value: "rounds_time__six", name: "Время" },
        { text: "7-Р", value: "rounds_time__seven", name: "Время" },
        { text: "8-Р", value: "rounds_time__eight", name: "Время" },
        { text: "9-Р", value: "rounds_time__nine", name: "Время" },
        {
          text: "Разница\nвремени",
          value: "round_time_diff",
          name: "Разница времени",
        },
        { text: "М", value: "round_time__min_time", name: "Меньшее" },
        { text: "<", value: "time_coef__min_coef_less", name: "Меньшее" },
        { text: ">", value: "time_coef__min_coef_more", name: "Меньшее" },
        { text: "С", value: "time_coef__mean_time", name: "Среднее" },
        { text: "<", value: "time_coef__mean_coef_less", name: "Среднее" },
        { text: ">", value: "time_coef__mean_coef_more", name: "Среднее" },
        { text: "Б", value: "time_coef__max_time", name: "Большее" },
        { text: "<", value: "time_coef__max_coef_less", name: "Большее" },
        { text: ">", value: "time_coef__max_coef_more", name: "Большее" },
      ],
      // pair_stats: { text: "ID", value: "game_id", name: "id" },
      games: [[], [], [], [], [], [], [], [], [], []],
      changed: 0,
      popup: false,
      colors_popup: false,
      text: "Цвета сохранены",
      polling: null,
      gamesLoading: true,
      dataLoading: false,
      url: "api/stats/",
      template_url: "/templates/get_template/",
      sub_url: "/subscription",
      expire_date: "",
      scale: 8,
      mean_less: {
        backgroundColor: "#cccccc",
      },
      // page_sizes: [25, 50, 75, 100, 150, 200],
      // page_size: 200,
      sub_type: "",
    };
  },
  watch: {
    scale: function (new_val, old_val) {
      console.log("OLD val " + old_val + "new val: " + new_val);
      if (new_val > 9) {
        this.scale = 9;
      }
      if (new_val <= 2) {
        this.scale = 2;
      }

      this.changeViewPort();
    },
  },
  methods: {
    ...mapGetters([
      "getHighlightFighters",
      "getHighlightTimes",
      "getFormData",
      "getCurrentPage",
      "getSettings",
      "getTotalGames",
      "getCurrentTemplate",
      "cols",
      "getPageSize",
      "getSubType",
      "getExpireDate",
      "getTemplates",
      "getIsTemplateChanged",
    ]),
    ...mapMutations([
      "cleanAllFormData",
      "addCol",
      "deleteCol",
      "cleanSettings",
      "setUserTemplates",
    ]),
    ...mapActions(["fetchUserSub", "setFilterKey"]),

    colorsPop() {
      console.log("Popup");
      this.colors = true;
    },
    prepareTime(game) {
      return game.timestamp[0].time_of_day.split(":").slice(0, 2).join(":");
    },
    setFighters(fighters) {
      console.log(fighters);
      let left_fighter = fighters.left_fighter;
      this.setFilterKey({
        key: "fighters__left_fighter",
        value: left_fighter,
      });
      let right_fighter = fighters.right_fighter;
      this.setFilterKey({
        key: "fighters__right_fighter",
        value: right_fighter,
      });
      this.getData();
      this.$refs["left_fighter"].selected = left_fighter;
      this.$refs["right_fighter"].selected = right_fighter;
    },
    setDayTime(daytime) {
      console.log(daytime);
      let hour = daytime.split(":")[0];
      let minute = daytime.split(":")[1];
      let value = "^" + hour + ":" + minute + ":00$";
      console.log(value);
      this.setFilterKey({
        key: "timestamp__time_of_day__regex",
        value: value,
      });
      this.getData();
      this.$refs["daytime"].selectedHour = hour;
      this.$refs["daytime"].selectedMinute = minute;
    },
    declOfNumMin(n) {
      var text_forms = ["минута", "минуты", "минут"];
      // console.log(n);
      return this.declOfNum(n, text_forms);
    },

    declOfNumHour(n) {
      var text_forms = ["час", "часа", "часов"];
      // console.log(n);
      return this.declOfNum(n, text_forms);
    },
    declOfNumDay(n) {
      var text_forms = ["день", "дня", "дней"];
      // console.log(n);
      return this.declOfNum(n, text_forms);
    },
    declOfNum(n, text_forms) {
      n = Math.abs(n) % 100;
      var n1 = n % 10;
      if (n > 10 && n < 20) {
        return text_forms[2];
      }
      if (n1 > 1 && n1 < 5) {
        return text_forms[1];
      }
      if (n1 == 1) {
        return text_forms[0];
      }
      return text_forms[2];
    },
    inCols(value) {
      // console.log(value + " in cols");
      var cols = this.getSettings().cols;
      if (cols.indexOf(value) != -1) {
        // console.log(value + " in cols: true");
        return true;
      }
      // console.log(value + " in cols: false");
      return false;
    },
    filterCols(list) {
      var columns = [];
      // console.log("List: " + JSON.stringify(list));
      var cols = this.getSettings().cols;
      // console.log("Current cols: " + JSON.stringify(cols));
      list.forEach(function (elem) {
        // :NEW
        // if (elem.name == "pair_stats") columns.push(elem);

        if (cols.indexOf(elem.name) != -1) {
          // console.log("Elem: " + elem.name, "Index" + index);
          columns.push(elem);
        }
      });
      // console.log("Result filter cols:" + JSON.stringify(columns));
      return columns;
      // for (var c in list) {
      //   if (cols.indexOf(c.name)) {
      //     console.log("Cur:" + JSON.stringify(c));
      //     columns.push(c);
      //     console.log("Pushing: " + c.name);
      //   }
      // }
      // return columns;
    },
    isFinish: function (round, coefs = "") {
      // console.log("Settings: " + JSON.stringify(this.getSettings()));
      var settings = this.getSettings();
      // console.log("Settings: " + settings);
      if (settings == null) {
        return "#FFFFFF";
      }
      var finishes = this.getSettings().highlights.rounds;
      if (!finishes) {
        return "#FFFFFF";
      }

      // console.log("FINISHES: " + JSON.stringify(finishes));
      if (finishes.includes("fav")) {
        var left_coef = coefs.wlr;
        var right_coef = coefs.wrr;
        if (left_coef < right_coef && round.includes("1:0")) {
          return this.colors["fav_win"].hex;
        }
        if (left_coef > right_coef && round.includes("0:1")) {
          return this.colors["fav_win"].hex;
        }
        if (left_coef == right_coef && round.includes("1:0")) {
          return this.colors["fav_win"].hex;
        }
        return "#FFFFFF";
      } else if (finishes.includes("out")) {
        var l_coef = coefs.wlr;
        var r_coef = coefs.wrr;
        if (l_coef < r_coef && round.includes("0:1")) {
          return this.colors["out_win"].hex;
        }
        if (l_coef > r_coef && round.includes("1:0")) {
          return this.colors["out_win"].hex;
        }
        if (l_coef == r_coef && round.includes("1:0")) {
          return this.colors["out_win"].hex;
        }
        return "#FFFFFF";
      }
      if (finishes.includes("FB")) {
        if (round.includes("F")) return this.colors["fat"].hex;
        if (round.includes("B")) return this.colors["brut"].hex;
      }
      if (finishes.includes("FBR")) {
        if (round.includes("F")) return this.colors["fat"].hex;
        if (round.includes("B")) return this.colors["brut"].hex;
        if (round.includes("R")) return this.colors["hand"].hex;
      }
      if (finishes.includes("B")) {
        return round.includes("B") ? this.colors["brut"].hex : null;
      }
      if (finishes.includes("F")) {
        return round.includes("F") ? this.colors["fat"].hex : null;
      }
      if (finishes.includes("R")) {
        return round.includes("R") ? this.colors["hand"].hex : null;
      }
      if (finishes.includes("1:0")) {
        return round.includes("1:0") ? this.colors["w1"].hex : null;
      }
      if (finishes.includes("0:1")) {
        return round.includes("0:1") ? this.colors["w2"].hex : null;
      }
    },
    isHighlight: function (game, type) {
      var highlights = this.getSettings().highlights.fighters;
      if (!highlights) {
        return "#FFFFFF";
      }

      if (!game.score) {
        return "#FFFFFF";
      }
      var first_score = game.score[0].first_score;
      var second_score = game.score[0].second_score;
      var left = game.coefs[0].wl;
      var right = game.coefs[0].wr;

      if (highlights.includes("win")) {
        if (type == "left") {
          if (first_score == 5) {
            return this.colors["winner"].hex;
          }
        } else if (type == "right") {
          if (second_score == 5) {
            return this.colors["winner"].hex;
          }
        }
      }
      if (highlights.includes("5:")) {
        if (type == "left") {
          if (first_score == 5) {
            return this.colors["winner"].hex;
          }
        }
      }

      if (highlights.includes(":5")) {
        if (type == "right") {
          if (second_score == 5) {
            return this.colors["winner"].hex;
          }
        }
      }

      if (highlights.includes("out")) {
        if (type == "right") {
          if (second_score == 5) {
            if (right > left) return this.colors["out_win"].hex;
          }
        }
        if (type == "left") {
          if (first_score == 5) {
            if (right < left) return this.colors["out_win"].hex;
          }
        }
      }

      if (highlights.includes("fav")) {
        if (type == "right") {
          if (second_score == 5) {
            if (right < left) return this.colors["fav_win"].hex;
          }
        }
        if (type == "left") {
          if (first_score == 5) {
            if (right > left) return this.colors["fav_win"].hex;
          }
        }
      }

      var rnds = this.rounds(game);
      var score = this.score(game);
      if (highlights.includes("1:0 F")) {
        if (type == "left") {
          if (this.arrayIncludes(rnds, score, "1:0 F")) {
            if (type == "left") return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("0:1 F")) {
        if (type == "right") {
          if (this.arrayIncludes(rnds, score, "0:1 F")) {
            return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("1:0 B")) {
        if (type == "left") {
          if (this.arrayIncludes(rnds, score, "1:0 B")) {
            if (type == "left") return this.colors["brut"].hex;
          }
        }
      }

      if (highlights.includes("0:1 B")) {
        if (type == "right") {
          if (this.arrayIncludes(rnds, score, "0:1 B")) {
            return this.colors["brut"].hex;
          }
        }
      }

      if (highlights.includes("1:1 F")) {
        let includes_first = this.arrayIncludes(rnds, score, "1:0 F");
        if (type == "left") {
          if (includes_first) {
            return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("1:1 F")) {
        let includes_right = this.arrayIncludes(rnds, score, "0:1 F");
        if (type == "right") {
          if (includes_right) {
            return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("1:1 F")) {
        let includes_first = this.arrayIncludes(rnds, score, "1:0 F");
        if (type == "left") {
          if (includes_first) {
            return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("1:1 F")) {
        let includes_right = this.arrayIncludes(rnds, score, "0:1 F");
        if (type == "right") {
          if (includes_right) {
            return this.colors["fat"].hex;
          }
        }
      }

      if (highlights.includes("1:1 B")) {
        let includes_first = this.arrayIncludes(rnds, score, "1:0 B");
        if (type == "left") {
          if (includes_first) {
            return this.colors["brut"].hex;
          }
        }
      }

      if (highlights.includes("1:1 B")) {
        let includes_right = this.arrayIncludes(rnds, score, "0:1 B");
        if (type == "right") {
          if (includes_right) {
            return this.colors["brut"].hex;
          }
        }
      }
    },
    getWinnerMatchCoefClass(type, game) {
      var highlights = this.getSettings().highlights.winner_match_coefs;
      if (!highlights) {
        return "#FFFFFF";
      }

      if (!game.score) {
        return "#FFFFFF";
      }
      var first_score = game.score[0].first_score;
      var second_score = game.score[0].second_score;
      var left = game.coefs[0].wl;
      var right = game.coefs[0].wr;

      // console.log(JSON.stringify(highlights));
      if (highlights.includes("win")) {
        if (type == "left") {
          if (first_score == 5) {
            return this.colors["w1"].hex;
          }
        } else if (type == "right") {
          if (second_score == 5) {
            return this.colors["w2"].hex;
          }
        }
      }
      if (highlights.includes("5:")) {
        if (type == "left") {
          if (first_score == 5) {
            return this.colors["w1"].hex;
          }
        }
      }

      if (highlights.includes(":5")) {
        if (type == "right") {
          if (second_score == 5) {
            return this.colors["w2"].hex;
          }
        }
      }

      if (highlights.includes("out")) {
        if (type == "right") {
          if (second_score == 5) {
            if (right > left) return this.colors["out_win"].hex;
          }
        }
        if (type == "left") {
          if (first_score == 5) {
            if (right < left) return this.colors["out_win"].hex;
          }
        }
      }

      if (highlights.includes("fav")) {
        if (type == "right") {
          if (second_score == 5) {
            if (right < left) return this.colors["fav_win"].hex;
          }
        }
        if (type == "left") {
          if (first_score == 5) {
            if (right > left) return this.colors["fav_win"].hex;
          }
        }
      }
      // if (!highlights.includes(type)) {
      //   return false;
      // }
      // if (rounds[highlights] == type) {
      //   return this.colors["winner"].hex;
      // }
    },
    getWinnerCoefClass(type, rounds) {
      var highlights_rnd = this.getSettings().highlights.winner_coefs;
      if (!highlights_rnd) {
        // console.log("NO winner coefs" + type + rounds);
        return "#FFFFFF";
      }
      // if (!highlights.includes(type)) {
      //   return false;
      // }
      if (rounds[highlights_rnd] == type) {
        return this.colors["winner_coef"].hex;
      }
    },
    getFinishCoefClass(type, rounds) {
      var highlights = this.getSettings().highlights.finish_coefs;
      if (!highlights) {
        return "#FFFFFF";
      }
      if (!highlights.includes(type)) {
        return "#FFFFFF";
      }
      for (var rnd in rounds) {
        if (rounds[rnd].includes(type)) {
          switch (type) {
            case "F":
              return this.colors["fat"].hex;
            case "B":
              return this.colors["brut"].hex;
            case "R":
              return this.colors["hand"].hex;
          }
        }
      }
    },
    timeClass(game, round_time) {
      var highlights = this.getSettings().highlights.time;
      if (!highlights) {
        return "#FFFFFF";
      }
      if (highlights.includes("off")) {
        return "#FFFFFF";
      }

      // console.log(game, round_time, highlights);
      if (round_time == 0) return;
      if (highlights.includes("on")) {
        if (round_time > game.round_time[0].max_time) {
          // return "max_more";
          // console.log(JSON.stringify(this.colors));
          return this.colors["max_more"].hex;
        }
        if (round_time < game.round_time[0].min_time) {
          return this.colors["min_less"].hex;
        }
        if (round_time < game.round_time[0].mean_time) {
          return this.colors["mean_less"].hex;
        }
        if (round_time > game.round_time[0].mean_time) {
          return this.colors["mean_more"].hex;
        }
      }

      if (highlights.includes("max_less")) {
        if (round_time < game.round_time[0].max_time) {
          return this.colors["max_less"].hex;
        }
      }

      if (highlights.includes("mean_less")) {
        if (round_time < game.round_time[0].mean_time) {
          return this.colors["mean_less"].hex;
        }
      }
      if (highlights.includes("min_less")) {
        if (round_time < game.round_time[0].min_time) {
          return this.colors["min_less"].hex;
        }
      }

      if (highlights.includes("max_more")) {
        if (round_time > game.round_time[0].max_time) {
          return this.colors["max_more"].hex;
        }
      }

      if (highlights.includes("mean_more")) {
        if (round_time > game.round_time[0].mean_time) {
          return this.colors["mean_more"].hex;
        }
      }
      if (highlights.includes("min_more")) {
        if (round_time > game.round_time[0].min_time) {
          return this.colors["min_more"].hex;
        }
      }
      if (highlights.includes("mean_less_more")) {
        if (round_time < game.round_time[0].mean_time) {
          return this.colors["mean_less"].hex;
        }
        if (round_time > game.round_time[0].mean_time) {
          // return this.mean_less;
          return this.colors["mean_more"].hex;
          // var colors = this.getSettings().colors;
          // for (const value of colors) {
          // if (value.name == "mean_more") {
          //   return { backgroundColor: value.hex };
          // }
          // }
        }
      }
    },
    arrayIncludes(rnds, scr, symbol) {
      // console.log("Checking if " + rnds + " includes " + symbol);
      if (!scr) {
        return false;
      }
      for (var rnd in rnds) {
        // console.log(`${scr} includes ${symbol}: ${scr.includes(symbol)}`);
        if (rnds[rnd] == symbol || scr.includes(symbol)) {
          return true;
        } else {
          // console.log(rnds[rnd] + " != " + symbol);
        }
      }
    },
    first_score(game) {
      //return game.score[0].first_score;
      if (game.score && game.score[0]) {
         return game.score[0].first_score;
       }
       return undefined;
    },
    second_score(game) {
      if (game.score && game.score[0]) {
         return game.score[0].second_score;
       }
       return undefined;
    },
    raw_rounds: function (game) {
      return game.rounds_view[0];
    },
    rounds: function (game) {
      if (!game.rounds_view_f) {
        // console.log("SHIT: " + JSON.stringify(game));
        return [];
      }
      // var rnds = game.rounds_view_f[0]
      // var rnds_full = []
      // for (let [index, val] of rnds.entries()) {
      //   console.log(index, val)
      // }
      // for (var rnd in rnds) {
      //   console.log(rnd)
      //   rnds_full
      //   for (var )
      // }
      return game.rounds_view_f[0];
    },
    score(game) {
      if (!game.score) {
        return "0:0";
      }
      var score = game.score[0];
      return `${score.first_score}:${score.second_score}`;
    },
    updateSelection(ref_name, value) {
      //TODO: clear form data
      // this.cleanAllFormData();
      // console.log("REF NAME: " + ref_name, value);
      // console.log("ALL REFS: " + JSON.stringify(() => this.$refs));
      this.$nextTick(function () {
        var ref = this.$refs[ref_name];
        if (ref == null) {
          // console.log("THere is no ref with name: " + ref_name);
          return;
        }
        this.$refs[ref_name].setSelected(value);
      });
    },
    clearSelection(ref_name) {
      this.$nextTick(function () {
        this.$refs[ref_name].clear();
      });
    },
    changeViewPort() {
      var content = `width=device-width, initial-scale=0.${this.scale}, maximum-scale=1, user-scalable=no, minimal-ui`;
      console.log(content);
      document
        .querySelector("meta[name='viewport']")
        .setAttribute("content", content);
      document.body.style.zoom = "80%";
    },
    async getData() {
      // console.log("URL:" + this.url);
      // console.log("form data:" + JSON.stringify(this.getFormData()));
      // console.log("Current page: " + this.getCurrentPage());
      let url =
        this.url +
        "?page=" +
        this.getCurrentPage() +
        "&page_size=" +
        this.getPageSize();
      // this.$http
      try {
        const response = await api.post(url, this.getSettings().filters);
        this.games = response.data.results;
        this.$store.dispatch({
          type: "setTotalGamesCount",
          count: response.data.count,
        });
      } catch (error) {
        console.log(JSON.stringify(error));
        // this.cleanSettings();
        console.log(error.data);
        console.log(error.status);
        // if (error.message.includes("501")) {
        //   console.log("ПЯТИСОТКА");
        // }
      }
      this.dataLoading = false;
    },

    fetchSubscription: function () {
      api
        .get(this.sub_url)
        .then((response) => {
          var sub = response.data[0];
          this.expire_date = sub.expire_date;
          this.sub_type = sub.subscription;
          // console.log("SUB:" + JSON.stringify(sub));
          // this.setUserTemplates({ value: response.data });
          // console.log("templates:" + JSON.stringify(this.templates));
          //   this.loading = false;
        })
        .catch((error) => {
          console.log("Sub: " + error.data);
        });
    },
    fetchTemplates: function () {
      // console.log("Fetching templates...");
      api
        .get(this.template_url)
        .then((response) => {
          this.templates = response.data;
          this.setUserTemplates({ value: response.data });
          // console.log("templates:" + JSON.stringify(this.templates));
          //   this.loading = false;
        })
        .catch((error) => {
          console.log("Template" + error.data);
        });
    },
    updateData() {
      this.polling = setInterval(() => {
        this.getData();
      }, 15000);
    },
  },
  beforeDestroy() {
    if (this.isMobile) {
      this.scale = 9;
      this.changeViewPort();
    }
    clearInterval(this.polling);
  },
  // mounted() {
  //   // console.log(
  //   //   "REFS MOTHR: " + JSON.stringify(this.$refs["rounds_view__one_view"])
  //   // );
  // },
  async created() {
    this.dataLoading = true;
    await this.fetchUserSub();
    await this.getIsTemplateChanged();
    await this.getData();
    // this.colors = await this.getSettings().colors;
    // console.log("COLORS: " + JSON.stringify(this.colors));
    this.dataLoading = false;
    this.updateData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main_table {
  box-shadow: 3px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 0px;
}
a {
  color: #42b983;
}
td {
  padding: 5 !important;
  overflow-wrap: anywhere;
  min-width: 10px;
  max-width: 130px;
  max-height: 50px;
  padding-top: 0;
}
@import url("https://fonts.googleapis.com/css2?family=Prosto+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Istok+Web:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Cuprum:wght@500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Play:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;700&display=swap");
@import "~vuetify/src/styles/styles.sass";

.mygrey {
  font-weight: 500;
  background-color: #eeeeee;
  color: #888888;
}

.winner {
  background-color: map-get($green, lighten-2);
}

.winner_coef {
  background-color: map-get($orange, lighten-2);
}

.rusk {
  background-color: map-get($orange, lighten-3);
}

.brut {
  /* green lighten-3 */
  /* background-color: #a5d6a7; */
  background-color: map-get($green, lighten-2);
}

.fat {
  background-color: map-get($red, lighten-2);
}

.hand {
  background-color: map-get($blue-grey, lighten-4);
  // background-color: map-get($brown, lighten-4);
}
.out {
  background-color: map-get($yellow, lighten-3);
}
.fav {
  background-color: pink;
}
.w1 {
  background-color: map-get($yellow, lighten-3);
}

.w2 {
  background-color: map-get($purple, lighten-3);
}

.fav_win {
  background-color: map-get($deep-purple, lighten-3);
}

.out_win {
  background-color: map-get($deep-orange, lighten-2);
}

/* Time */

.min_less {
  background-color: map-get($green, lighten-2);
}

.min_more {
  background-color: map-get($red, lighten-2);
}

.mean_less {
  background-color: map-get($green, lighten-4);
}

.mean_more {
  background-color: map-get($red, lighten-4);
}

.max_less {
  background-color: map-get($green, lighten-2);
}

.max_more {
  background-color: map-get($red, lighten-2);
}

// .min_less {
//   background-color: #a5fda8;
// }

// .mean_less {
//   background-color: #ccffac;
// }

// .mean_more {
//   background-color: #ffb2b2;
// }

// .max_more {
//   background-color: #e9928a;
// }

table caption {
  font-family: "Cuprum", sans-serif;
}

.v-application .body-1,
.v-application .caption {
  font-family: "Cuprum", sans-serif !important;
}
.v-application .text-md-body-2,
.v-application .text-md-button {
  font-size: 0.875rem !important;
  font-family: "Cuprum", sans-serif !important;
}
table td {
  border: 1px solid rgba(0, 0, 0, 0.12);
  /* border-width: thin; */
  /* border-style: solid; */
  /* font-size: 21px; */
  /* padding: 1px 5px;
  margin-top: 1px; */
  white-space: nowrap;
  /* overflow: hidden; */
  /* height: 30px; */

  /* letter-spacing: 0.5; */
  /* font-family: "Istok Web", sans-serif; */
  /* GOOD ONE */
  font-family: "Cuprum", sans-serif;
  /* font-family: "Play", sans-serif; */
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.9rem;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 0.8em;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
</style>
